import React, { useState, useEffect, useRef, useMemo } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import { auth, analytics, db } from "./firebase";
import { signOut } from "firebase/auth";
import Swal from 'sweetalert2'
import './styles/styles.css';
import bg2 from './assets/bg2.png';
import MatchHistorySection from "./components/matchHistory";
import RealtimeWaitingTime from "./components/RealtimeWaitingTime";
import Accordion from 'react-bootstrap/Accordion';
import { logEvent } from "firebase/analytics";
import PlayersListSection from "./components/PlayersListSection";
import QueuePlayerGrid from "./components/QueuePlayerGrid";
import { collection, onSnapshot, query, orderBy, updateDoc, doc, setDoc, serverTimestamp, writeBatch, where, getDoc, arrayUnion } from "firebase/firestore";
import { CLUB_ID, LEVELS_MAP, THEME_COLOR, levelColor, CLUB_NAME } from "./config/club";
import { onAuthStateChanged } from "firebase/auth";
import { useAuth } from "./context/AuthContext";
import { useSession } from "./context/SessionContext";
import AdminSessionBar from "./components/admin/AdminSessionBar";
import AdminMatchRequests from "./components/admin/AdminMatchRequests";
import BulkAddSection from "./components/BulkAddSection";
import SettingsModal from "./components/SettingsModal";
import { useNavigate } from "react-router-dom";
import AdminScanPlayerModal from "./components/admin/AdminScanPlayerModal";
import SessionPayments from "./components/admin/SessionPayments";
import EditMatchModal from "./components/admin/EditMatchModal";
import PlayersModal from "./components/admin/PlayersModal";
import PaymentsCalculatorModal from "./components/admin/PaymentsCalculator";
import SmartWaitingBadge from "./components/SmartWaitingBadge";
import toast from 'react-hot-toast';
import {
  DndContext,
  closestCenter,
} from "@dnd-kit/core";

import {
  SortableContext,
  useSortable,
  arrayMove,
  horizontalListSortingStrategy,
  rectSortingStrategy,
  verticalListSortingStrategy
} from "@dnd-kit/sortable";
import { CSS } from "@dnd-kit/utilities";
import { QRCodeCanvas } from "qrcode.react";
import { useTheme } from "./context/ThemeContext";
/* ================= DRAGGABLE CHIP ================= */
function DraggablePlayerChip({ player, index, onRemove, levelColor }) {
  const {
    attributes,
    listeners,
    setNodeRef,
    transform,
    transition,
  } = useSortable({ id: player.id });

  const style = {
    transform: CSS.Transform.toString(transform),
    transition,
    cursor: "grab",
    backgroundColor: levelColor(player.level)
  };

  return (
    <span
      ref={setNodeRef}
      style={style}
      {...attributes}
      {...listeners}
      className="d-flex align-items-center gap-2 px-3 py-2 rounded-pill border text-dark shadow-sm"
    >
      <span className="fw-semibold small">{player.name}</span>
    </span>
  );
}
function DraggableQueueControls({
  idx,
  dragAttributes,
  dragListeners
}) {
  return (
    <div className="d-flex align-items-center gap-2 flex-shrink-0">

      {/* Drag Handle */}
      <span
        className="drag-handle"
        {...dragAttributes}
        {...dragListeners}
      >
        <i className="bi bi-grip-vertical"></i>
      </span>

      {/* Match Number */}
      <span className="match-number">
        {idx + 1}
      </span>

    </div>
  );
}
function QueueMoveButtons({
  idx,
  queuedMatches,
  moveMatchToTop,
  moveMatchUp,
  moveMatchDown
}) {
  return (
    <div className="d-flex align-items-center gap-1 flex-shrink-0">

      <button
        className="btn btn-sm border queue-btn"
        onClick={(e) => {
          e.stopPropagation();
          moveMatchToTop(idx);
        }}
        disabled={idx <= 1}
        hidden={idx <= 1}
      >
        <i className="bi bi-chevron-double-up"></i>
      </button>

      <button
        className="btn btn-sm border queue-btn"
        onClick={(e) => {
          e.stopPropagation();
          moveMatchUp(idx);
        }}
        disabled={idx === 0}
        hidden={idx === 0}
      >
        <i className="bi bi-chevron-up"></i>
      </button>

      <button
        className="btn btn-sm border queue-btn"
        onClick={(e) => {
          e.stopPropagation();
          moveMatchDown(idx);
        }}
        disabled={idx === queuedMatches.length - 1}
        hidden={idx === queuedMatches.length - 1}
      >
        <i className="bi bi-chevron-down"></i>
      </button>

    </div>
  );
}
function DraggableMatchRow({
  match,
  idx,
  queuedMatches,
  moveMatchToTop,
  moveMatchUp,
  moveMatchDown,
  children
}) {
  const {
    attributes,
    listeners,
    setNodeRef,
    transform,
    transition
  } = useSortable({ id: match.id });

  const style = {
    transform: CSS.Transform.toString(transform),
    transition
  };

  return (
    <div
      ref={setNodeRef}
      style={style}
      className="list-group-item border-0 border-bottom-dashed py-2 px-2"
    >
      <div className="d-flex align-items-center w-100">

        {/* LEFT: Drag + Number */}
        <DraggableQueueControls
          idx={idx}
          dragAttributes={attributes}
          dragListeners={listeners}
        />

        {/* CENTER: Match Content */}
        <div className="flex-grow-1 mx-2">
          {children}
        </div>

        {/* RIGHT: Arrows */}
        <QueueMoveButtons
          idx={idx}
          queuedMatches={queuedMatches}
          moveMatchToTop={moveMatchToTop}
          moveMatchUp={moveMatchUp}
          moveMatchDown={moveMatchDown}
        />

      </div>
    </div>
  );
}
export default function BadminQueueApp() {
  const [players, setPlayers] = useState([]);
  const [queue, setQueue] = useState([]);
  const [playing, setPlaying] = useState([]);
  const [gamesPlayed, setGamesPlayed] = useState({});
  const [playerLevels, setPlayerLevels] = useState({});
  const [nameInput, setNameInput] = useState("");
  const [courts, setCourts] = useState(9);
  const [manualSelection, setManualSelection] = useState([]);
  const [matchStartTimes, setMatchStartTimes] = useState({});
  const [matchHistory, setMatchHistory] = useState([]);
  const [courtAssignments, setCourtAssignments] = useState({});
  const [showAutoConfirm, setShowAutoConfirm] = useState(false);
  const [autoMatchPlayers, setAutoMatchPlayers] = useState([]);
  const [matchScores, setMatchScores] = useState({});
  const [searchTerm, setSearchTerm] = useState("");
  const [queueSearch, setQueueSearch] = useState("");
  const [lookForPlayers, setLookForPlayers] = useState(12);
  const sectionRef = useRef(null);
  const [defaultLevel, setDefaultLevel] = useState(1);
  const [maxLevelDiff, setMaxLevelDiff] = useState(2);
  const [showSettings, setShowSettings] = useState(false);
  const [showPaymentModal, setShowPaymentModal] = useState(false);
  const [editingMatch, setEditingMatch] = useState(false);
  const [queuedMatches, setQueuedMatches] = useState([]); // List of { players: [], selectedCourt: null }
  const [sortBy, setSortBy] = useState("games");
  const [sortDirection, setSortDirection] = useState("desc"); // "asc" or "desc"
  const [isCollapsed, setIsCollapsed] = useState(true);
  const [authReady, setAuthReady] = useState(false);
  const { user, loading, loginGoogle, loginGuest, logout, mode } = useAuth();
  const { sessionId, session } = useSession();
  const [showScan, setShowScan] = useState(false);
  const [showPlayersModal, setShowPlayersModal] = useState(false);
  const [showQr, setShowQr] = useState(false);
  const [isCalcOpen, setCalcOpen] = useState(false);
  const joinUrl = `${process.env.REACT_APP_MAIN_LINK}/join?club=${CLUB_ID}&session=${sessionId}`;
  const [showCourtModal, setShowCourtModal] = useState(false);
  const [courtModalMatch, setCourtModalMatch] = useState(null);
  const [courtFilter, setCourtFilter] = useState("");
  const [sortStarted, setSortStarted] = useState("oldest");
  const { darkMode, setDarkMode } = useTheme();
  //settings
  // Default to 5 per row on large screens
  const [showAutoMatch, setShowAutoMatch] = useState(true);
  const [colsCount, setColsCount] = useState(6);
  const [longWaitThreshold, setLongWaitThreshold] = useState(30);
  const [limitTeammatesEnabled, setLimitTeammatesEnabled] = useState(true);
  const [limitRivalsEnabled, setLimitRivalsEnabled] = useState(true);

  const [maxTeammates, setMaxTeammates] = useState(1);
  const [maxRivals, setMaxRivals] = useState(2);
  const [maxTeamDiff, setMaxTeamDiff] = useState(1);

  const navigate = useNavigate();

  const CheckInToastShow = (type, message) => {
    if (type === "success") {
      toast.success(message, {
        duration: 10000,
        iconTheme: {
          primary: '#4CAF50',
          secondary: '#FFF',
        },
      });
    } else if (type === "error") {
      toast.error(message);
    } else {
      toast(message); // Standard toast
    }
  };

  useEffect(() => {
    const unsub = onAuthStateChanged(auth, (user) => {
      if (user) setAuthReady(true);
    });
    return () => unsub();
  }, []);

  useEffect(() => {
    if (!session || session.status !== "active") {
      navigate("/admin/select-session", { replace: true });
    }
  }, [session]);

  const playingNames = useMemo(() => {
    // flatten → ["ssdqdqdsqdq", "cxvvxvxvxqvxvq", ...]
    return new Set(playing.flat().map((pl) => pl.name));
  }, [playing]);

  const queuedMatchesNames = useMemo(() => {
    return new Set(
      queuedMatches
        .flatMap(match => match.players.map(player => player.name))
    );
  }, [queuedMatches]);


  const initialLoad = useRef(true);

  useEffect(() => {
    let unsubscribePlayers = null;

    const unsubscribeAuth = onAuthStateChanged(auth, (user) => {
      if (!user) return; // ⛔ wait until authenticated

      const q = query(
        collection(db, "clubs", CLUB_ID, "sessions", sessionId, "players")
      );

      unsubscribePlayers = onSnapshot(q, (snap) => {

        // ⛔ Skip toast on initial snapshot
        if (initialLoad.current) {
          initialLoad.current = false;
          setPlayers(
            snap.docs.map((doc) => ({
              id: doc.id,
              ...doc.data(),
            }))
          );
          return;
        }

        // ✅ Toast ONLY real-time joins
        snap.docChanges().forEach((change) => {
          if (change.type === "added") {
            CheckInToastShow(
              "success",
              `${change.doc.data().name} checked in`
            );
          }
        });

        setPlayers(
          snap.docs.map((doc) => ({
            id: doc.id,
            ...doc.data(),
          }))
        );
      });
    });

    return () => {
      unsubscribeAuth();
      if (unsubscribePlayers) unsubscribePlayers();
    };
  }, []);

  useEffect(() => {
    const q = query(
      collection(db, "clubs", CLUB_ID, "sessions", sessionId, "queue"),
      orderBy("joinedAt", "asc")
    );

    const unsub = onSnapshot(q, (snap) => {
      const queueList = snap.docs.map((doc) => ({
        id: doc.id,
        ...doc.data(),
      }));

      setQueue(queueList);
    });
    return () => unsub();
  }, []);

  useEffect(() => {
    const levels = {};
    players.forEach(p => {
      levels[p.name] = p.level ?? defaultLevel;
    });
    setPlayerLevels(levels);
  }, [players]);
  useEffect(() => {
    const q = query(
      collection(db, "clubs", CLUB_ID, "sessions", sessionId, "matches"),
      where("status", "==", "playing")
    );

    return onSnapshot(q, snap => {
      const active = snap.docs.map(d => ({
        id: d.id,
        ...d.data(),
      }));
      setPlaying(active);
    });
  }, []);

  useEffect(() => {
    const q = query(
      collection(db, "clubs", CLUB_ID, "sessions", sessionId, "matches"),
      where("status", "==", "pending"),
      orderBy("createdAt")
    );

    const unsub = onSnapshot(q, (snap) => {
      const matches = snap.docs.map(d => ({
        id: d.id,
        ...d.data(),
        selectedCourt: "", // UI-only
      }));
      setQueuedMatches(matches);
    });

    return () => unsub();
  }, []);

  useEffect(() => {
    const q = query(
      collection(db, "clubs", CLUB_ID, "sessions", sessionId, "matches"),
      where("status", "==", "finished"),
      orderBy("endedAt", "asc")
    );

    return onSnapshot(q, snap => {
      const history = snap.docs.map(d => {
        const data = d.data();

        const start = data.startedAt?.toMillis?.() ?? null;
        const end = data.endedAt?.toMillis?.() ?? null;

        return {
          id: d.id,
          match: data.players || [],
          court: data.court || "N/A",
          startTime: start,
          endTime: end,
          duration: start && end ? end - start : 0,
          score: data.score || null,
        };
      });

      setMatchHistory(history);
    });
  }, []);

  useEffect(() => {
    const counts = {};

    matchHistory.forEach(entry => {
      if (!entry.match || entry.match.length !== 4) return;

      entry.match.forEach(player => {
        counts[player.name] = (counts[player.name] || 0) + 1;
      });
    });

    setGamesPlayed(counts);
  }, [matchHistory]);

  const targetRef = useRef(null);
  useEffect(() => {
  if (manualSelection.length === 4 && targetRef.current) {
    targetRef.current.scrollIntoView({
      behavior: 'smooth',
      block: 'start', // or 'center'
    });
  }
}, [manualSelection]);

  const filteredPlayers = players.filter((p) =>
    p.name.toLowerCase().includes(searchTerm.toLowerCase())
  );

  const Toast = Swal.mixin({
    toast: true,
    showConfirmButton: false,
    timer: 3000,
    timerProgressBar: true,
  });
  const ToastShow = (type, message) => {
    Toast.fire({
      icon: type,
      title: message,
    });
  };

  function MatchTimer({ startTime }) {
    const [elapsed, setElapsed] = useState(0);

    useEffect(() => {
      if (!startTime) return;

      // Firestore Timestamp → milliseconds
      const startMs =
        typeof startTime === "number"
          ? startTime
          : startTime.toMillis();

      const interval = setInterval(() => {
        setElapsed(Math.floor((Date.now() - startMs) / 1000));
      }, 1000);

      return () => clearInterval(interval);
    }, [startTime]);

    const formatTime = (seconds) => {
      const mins = String(Math.floor(seconds / 60)).padStart(2, "0");
      const secs = String(seconds % 60).padStart(2, "0");
      return `${mins}:${secs}`;
    };

    return (
      <div className="text-muted small">
        🕒 {formatTime(elapsed)}
      </div>
    );
  }

  const joinQueueFromQR = async ({ uid, name, username, photoURL, level }) => {
    if (!uid || !sessionId || !CLUB_ID) return;

    const now = Date.now();

    const userRef = doc(db, "users", uid);
    const playerRef = doc(db, "clubs", CLUB_ID, "sessions", sessionId, "players", uid);
    const queueRef = doc(db, "clubs", CLUB_ID, "sessions", sessionId, "queue", uid);
    const sessionRef = doc(db, "clubs", CLUB_ID, "sessions", sessionId);

    try {
      const existingQueue = await getDoc(queueRef);

      // Already in queue → ignore
      if (existingQueue.exists()) {
        ToastShow("info", `${name} is already in queue`);
        return;
      }

      const batch = writeBatch(db);

      // Update user profile (safe merge)
      batch.set(
        userRef,
        {
          displayName: name,
          username: username || null,
          photoURL: photoURL || null,
          updatedAt: serverTimestamp(),
        },
        { merge: true }
      );

      // Player session record
      batch.set(
        playerRef,
        {
          uid,
          name,
          username: username || null,
          photoURL: photoURL || null,
          level: level || "N/A",
          status: "waiting",
          waitingSince: now,
          joinedAt: serverTimestamp(),
          joinedVia: "admin_qr",
          scannedBy: user?.uid || "admin",
        },
        { merge: true }
      );

      // Queue entry
      batch.set(queueRef, {
        playerId: uid,
        name,
        username: username || null,
        photoURL: photoURL || null,
        level: level || "N/A",
        waitingSince: now,
        joinedAt: serverTimestamp(),
      });

      batch.update(sessionRef, {
        playerUids: arrayUnion(uid),
      });

      await batch.commit();

      ToastShow("success", `${name} added to queue`);
    } catch (err) {
      console.error(err);
      ToastShow("error", err);
    }
  };


  const addPlayers = async () => {
    //console.log(sessionId)
    if (!nameInput.trim()) {
      ToastShow("warning", "Please enter at least one player name");
      return;
    }

    const entries = nameInput
      .split(/[\n,]+/)
      .map((entry) => entry.trim())
      .filter(Boolean);

    const existingNames = new Set(players.map(p => p.name.toLowerCase()));
    const duplicateNames = [];
    const writes = [];

    entries.forEach((entry) => {
      const [nameRaw, levelStr] = entry.split("=").map(s => s.trim());
      const name = nameRaw;
      const level = Number(levelStr) || defaultLevel;

      if (existingNames.has(name.toLowerCase())) {
        duplicateNames.push(name);
        return;
      }

      const playerRef = doc(
        db,
        "clubs",
        CLUB_ID,
        "sessions",
        sessionId,
        "players",
        crypto.randomUUID()
      );

      writes.push(
        setDoc(playerRef, {
          name,
          level,
          joinedAt: serverTimestamp(),
          waitingSince: Date.now(),
          status: 'waiting',
          createdBy: user?.uid || "admin"
        })
      );
    });

    if (duplicateNames.length > 0) {
      Swal.fire({
        icon: "warning",
        title: "Duplicate Names",
        html: `These players already exist:<br><strong>${duplicateNames.join(", ")}</strong>`
      });
      return;
    }

    try {
      await Promise.all(writes);
      //ToastShow("success", "Player(s) added");
      setNameInput("");
    } catch (err) {
      console.error("Add player failed:", err);
      ToastShow("error", "Failed to add players");
    }
  };
  const addPlayers2 = async (playersToProcess) => {
    if (!playersToProcess || playersToProcess.length === 0) return;

    const existingNames = new Set(players.map(p => p.name.toLowerCase()));
    const duplicateNames = [];
    const writes = [];

    playersToProcess.forEach((p) => {
      if (existingNames.has(p.name.toLowerCase())) {
        duplicateNames.push(p.name);
        return;
      }

      const playerId = crypto.randomUUID();

      const playerRef = doc(db, "clubs", CLUB_ID, "sessions", sessionId, "players", playerId);
      const queueRef = doc(db, "clubs", CLUB_ID, "sessions", sessionId, "queue", playerId);

      writes.push(
        setDoc(playerRef, {
          name: p.name,
          level: p.level,
          joinedAt: serverTimestamp(),
          waitingSince: Date.now(),
          status: 'waiting',
          createdBy: user?.uid || "admin"
        })
      );

      // Queue collection
      writes.push(
        setDoc(queueRef, {
          playerId,
          name: p.name,
          username: p.username || null,
          photoURL: p.photoURL || null,
          level: p.level || 1,
          joinedAt: serverTimestamp(),
          waitingSince: Date.now(),
        })
      );
    });

    if (duplicateNames.length > 0) {
      Swal.fire({
        icon: "warning",
        title: "Duplicate Names",
        html: `Found duplicates:<br><strong>${duplicateNames.join(", ")}</strong>`
      });
      return;
    }

    try {
      await Promise.all(writes);
      ToastShow("success", `Added ${writes.length / 2} players`);
    } catch (err) {
      console.error(err);
      ToastShow("error", "Failed to add players");
    }
  };
  const updatePlayerLevel = async (id, level) => {
    if (!user) return; // ⛔ auth guard

    const player = players.find(p => p.id === id);
    if (!player) return;

    const newLevel = Number(level);

    try {
      const playerRef = doc(
        db,
        "clubs",
        CLUB_ID,
        "sessions",
        sessionId,
        "players",
        player.id
      );

      const queueRef = doc(
        db,
        "clubs",
        CLUB_ID,
        "sessions",
        sessionId,
        "queue",
        player.id
      );

      // 1️⃣ Always update player
      const writes = [
        updateDoc(playerRef, { level: newLevel })
      ];

      // 2️⃣ Update queue only if player exists there
      if (queue.some(q => q.playerId === player.id)) {
        writes.push(updateDoc(queueRef, { level: newLevel }));
      }

      await Promise.all(writes);

      ToastShow("success", `${player.name} level updated`);
    } catch (err) {
      console.error(err);
      ToastShow("error", "Failed to update level");
    }
  };

  const createPendingMatch = async ({ players, source }) => {
    const matchId = crypto.randomUUID();
    const batch = writeBatch(db);

    // 1️⃣ Create match
    batch.set(doc(db, "clubs", CLUB_ID, "sessions", sessionId, "matches", matchId), {
      id: matchId,
      players: players.map(p => ({
        photoURL: p.photoURL || null,
        username: p.username || null,
        waitingSince: p.waitingSince || null,
        id: p.id,
        name: p.name,
        level: p.level,
        joinedAt: p.joinedAt || null,
      })),
      status: "pending",
      source, // auto | manual
      createdAt: Date.now(), // 🔥 IMPORTANT (no serverTimestamp ordering bug)
      court: null,
    });

    // 2️⃣ Update player status → pending
    players.forEach(p => {
      batch.update(doc(db, "clubs", CLUB_ID, "sessions", sessionId, "players", p.id), {
        status: "pending",
      });

      // 3️⃣ Remove from queue
      batch.delete(doc(db, "clubs", CLUB_ID, "sessions", sessionId, "queue", p.id));
    });

    await batch.commit();
  };

  const startManualMatch = async () => {
    if (manualSelection.length !== 4) {
      return ToastShow("warning", "Select exactly 4 players");
    }

    // Create a PENDING match (same as auto)
    await createPendingMatch({
      players: manualSelection,
      source: "manual",
    });

    // Reset selection
    setManualSelection([]);

    // Scroll to confirmations
    setTimeout(() => {
      sectionRef.current?.scrollIntoView({
        behavior: "smooth",
        block: "start",
      });
    }, 100);
  };


  const startMatch = async (matchPlayers, court, matchId) => {
    const batch = writeBatch(db);

    // Match
    batch.update(
      doc(db, "clubs", CLUB_ID, "sessions", sessionId, "matches", matchId),
      {
        status: "playing",
        startedAt: serverTimestamp(),
        court,
      }
    );

    // Players
    matchPlayers.forEach(p => {
      batch.update(
        doc(db, "clubs", CLUB_ID, "sessions", sessionId, "players", p.id),
        {
          status: "playing",
          court,
        }
      );
    });

    await batch.commit();

    ToastShow("success", "Match started");
  };

  const haveBeenTeammates = (p1, p2) => {
    const pair = [p1.name, p2.name].sort().join("-");

    return matchHistory.some(entry => {
      const match = entry.match;
      if (!match || match.length < 4) return false;

      const t1 = [match[0].name, match[1].name].sort().join("-");
      const t2 = [match[2].name, match[3].name].sort().join("-");

      return pair === t1 || pair === t2;
    });
  };

  const getRivalries = (teamA, teamB) => {
    const rivalries = [];

    teamA.forEach(a => {
      teamB.forEach(b => {
        let count = 0;

        matchHistory.forEach(entry => {
          const match = entry.match;
          if (!match || match.length < 4) return;

          const t1 = [match[0].id, match[1].id];
          const t2 = [match[2].id, match[3].id];

          const faced =
            (t1.includes(a.id) && t2.includes(b.id)) ||
            (t1.includes(b.id) && t2.includes(a.id));

          if (faced) count++;
        });

        if (count > 0) {
          rivalries.push({
            a,
            b,
            count
          });
        }
      });
    });

    return rivalries;
  };


  const confirmAutoMatchOld = async () => {

    const candidates = queue.slice(0, lookForPlayers); // Look at first N players
    if (candidates.length < 4) return ToastShow("error", "Not enough players");

    let bestGroup = null;
    let bestTeams = null;
    let closestDiff = Infinity;

    // Generate all combinations of k items from array
    const combinations = (arr, k) => {
      const results = [];
      const helper = (start, combo) => {
        if (combo.length === k) {
          results.push(combo);
          return;
        }
        for (let i = start; i < arr.length; i++) {
          helper(i + 1, [...combo, arr[i]]);
        }
      };
      helper(0, []);
      return results;
    };

    // Generate all 2v2 team pairings for 4 players
    const teamCombos = (players) => {
      return [
        [[players[0], players[1]], [players[2], players[3]]],
        [[players[0], players[2]], [players[1], players[3]]],
        [[players[0], players[3]], [players[1], players[2]]],
      ];
    };

    // Check if max level gap in a team is <= 2
    const isLevelGapOk = (team) => {
      const levels = team.map((p) => p.level || 1);
      const max = Math.max(...levels);
      const min = Math.min(...levels);
      return max - min <= maxLevelDiff;
    };

    const groupsOf4 = combinations(candidates, 4);

    for (let group of groupsOf4) {
      const allTeamPairs = teamCombos(group);

      for (let [team1, team2] of allTeamPairs) {
        // Skip if either team has >2 level gap
        if (
          haveBeenTeammates(team1[0], team1[1]) ||
          haveBeenTeammates(team2[0], team2[1])
        ) continue;
        if (!isLevelGapOk(team1) || !isLevelGapOk(team2)) continue;

        const team1Level = team1.reduce((sum, p) => sum + (playerLevels[p.name] || 1), 0);
        const team2Level = team2.reduce((sum, p) => sum + (playerLevels[p.name] || 1), 0);
        const diff = Math.abs(team1Level - team2Level);

        if (diff < closestDiff) {
          closestDiff = diff;
          bestGroup = [...team1, ...team2];
          bestTeams = [team1, team2];
        }
      }
    }

    if (bestGroup) {
      await createPendingMatch({
        players: bestGroup,
        source: "auto",
      });

      setShowAutoConfirm(true);

      setTimeout(() => {
        sectionRef.current?.scrollIntoView({
          behavior: "smooth",
          block: "start",
        });
      }, 100);
    } else {
      ToastShow("error", "No balanced group found");
    }
  };

  const confirmAutoMatch = async () => {

    const candidates = queue.slice(0, lookForPlayers);

    if (candidates.length < 4) {
      return ToastShow("error", "Not enough players");
    }

    const anchor = candidates[0]; // longest waiting player

    let bestScore = Infinity;
    let bestTeams = null;
    let bestGroup = null;

    // ---------- PREPARE FAST LOOKUP MAPS ----------

    const teammateMap = {};
    const rivalryMap = {};

    matchHistory.forEach(entry => {

      const m = entry.match;
      if (!m || m.length < 4) return;

      const t1 = [m[0].id, m[1].id];
      const t2 = [m[2].id, m[3].id];

      const teamKey1 = [...t1].sort().join("-");
      const teamKey2 = [...t2].sort().join("-");

      teammateMap[teamKey1] = (teammateMap[teamKey1] || 0) + 1;
      teammateMap[teamKey2] = (teammateMap[teamKey2] || 0) + 1;

      t1.forEach(a => {
        t2.forEach(b => {
          const key = [a, b].sort().join("-");
          rivalryMap[key] = (rivalryMap[key] || 0) + 1;
        });
      });

    });

    const teammateCount = (p1, p2) => {
      const key = [p1.id, p2.id].sort().join("-");
      return teammateMap[key] || 0;
    };

    const rivalryCount = (p1, p2) => {
      const key = [p1.id, p2.id].sort().join("-");
      return rivalryMap[key] || 0;
    };

    const teamPairCount = (team) => {
      return teammateCount(team[0], team[1]);
    };

    const rivalryTotal = (team1, team2) => {
      return (
        rivalryCount(team1[0], team2[0]) +
        rivalryCount(team1[0], team2[1]) +
        rivalryCount(team1[1], team2[0]) +
        rivalryCount(team1[1], team2[1])
      );
    };

    // ---------- HELPERS ----------

    const combinations = (arr, k) => {
      const results = [];

      const helper = (start, combo) => {
        if (combo.length === k) {
          results.push(combo);
          return;
        }

        for (let i = start; i < arr.length; i++) {
          helper(i + 1, [...combo, arr[i]]);
        }
      };

      helper(0, []);
      return results;
    };

    const teamCombos = (players) => {
      return [
        [[players[0], players[1]], [players[2], players[3]]],
        [[players[0], players[2]], [players[1], players[3]]],
        [[players[0], players[3]], [players[1], players[2]]],
      ];
    };

    const levelSum = (team) =>
      team.reduce((s, p) => s + (playerLevels[p.name] || 1), 0);

    const levelGapOk = (team) => {
      const levels = team.map(p => p.level || 1);
      return Math.max(...levels) - Math.min(...levels) <= maxLevelDiff;
    };

    // ---------- MATCH SCORING ----------

    const calculateScore = (team1, team2, group) => {

      const levelDiff = Math.abs(levelSum(team1) - levelSum(team2));

      const rivalryScore = rivalryTotal(team1, team2);

      const teammatePenalty =
        teammateCount(team1[0], team1[1]) +
        teammateCount(team2[0], team2[1]);

      const waitBonus = group.reduce((sum, p) => {
        const minutes = (Date.now() - (p.joinedAt || Date.now())) / 60000;
        return sum - minutes;
      }, 0);

      return (
        levelDiff * 10 +
        rivalryScore * 6 +
        teammatePenalty * 5 +
        waitBonus
      );
    };

    // ---------- ANCHOR GROUP SEARCH ----------

    const otherPlayers = candidates.filter(p => p.id !== anchor.id);

    const groups = combinations(otherPlayers, 3).map(g => [anchor, ...g]);

    for (let group of groups) {

      const teamPairs = teamCombos(group);

      for (let [team1, team2] of teamPairs) {

        if (!levelGapOk(team1) || !levelGapOk(team2)) continue;

        const team1Total = levelSum(team1) / 2;
        const team2Total = levelSum(team2) / 2;

        const teamDiff = Math.abs(team1Total - team2Total);

        if (teamDiff > maxTeamDiff) continue;

        // ---------- TEAMMATE LIMIT ----------

        if (limitTeammatesEnabled) {

          const t1Count = teamPairCount(team1);
          const t2Count = teamPairCount(team2);

          if (t1Count >= maxTeammates || t2Count >= maxTeammates) {
            continue;
          }

        }

        // ---------- RIVAL LIMIT ----------

        if (limitRivalsEnabled) {

          const rivals = rivalryTotal(team1, team2);

          if (rivals >= maxRivals) {
            continue;
          }

        }

        const score = calculateScore(team1, team2, group);

        if (score < bestScore) {
          bestScore = score;
          bestTeams = [team1, team2];
          bestGroup = [...team1, ...team2];
        }

      }

    }

    // ---------- CREATE MATCH ----------

    if (bestGroup) {

      await createPendingMatch({
        players: bestGroup,
        source: "auto",
      });

      setShowAutoConfirm(true);

      setTimeout(() => {
        sectionRef.current?.scrollIntoView({
          behavior: "smooth",
          block: "start",
        });
      }, 100);

    } else {
      ToastShow("error", "No balanced match found");
    }

  };

  const proceedAutoMatch = async (players, court, matchId) => {
    await startMatch(players, court, matchId);
    setShowAutoConfirm(false);
    //setAutoMatchPlayers([]);
    setManualSelection([]);
  };

  const cancelPendingMatch = async (match) => {
    const batch = writeBatch(db);

    // 1️⃣ Delete match
    batch.delete(
      doc(db, "clubs", CLUB_ID, "sessions", sessionId, "matches", match.id)
    );

    // 2️⃣ Revert players → waiting
    match.players.forEach(p => {
      //console.log(p)
      let username = null;
      let photoLink = null;
      if (p.username) {
        username = p.username;
      } if (p.photoURL) {
        photoLink = p.photoURL;
      }
      batch.update(
        doc(db, "clubs", CLUB_ID, "sessions", sessionId, "players", p.id),
        {
          status: "waiting",
        }
      );
      batch.set(
        doc(db, "clubs", CLUB_ID, "sessions", sessionId, "queue", p.id),
        {
          playerId: p.id,
          photoURL: photoLink,
          waitingSince: p.waitingSince || null,
          joinedAt: p.joinedAt,
          username: username,
          name: p.name,
          level: p.level,
        }
      );
    });

    await batch.commit();

    ToastShow("info", "Match cancelled");
  };

  const finishMatch = async (match, matchScore) => {
    const score = matchScore;

    // Simple check: does it have numbers on both sides of the hyphen?
    if (!score || !/^\d+-\d+$/.test(score)) {
      ToastShow("error", "Please enter a complete score (e.g. 21-15)");
      return;
    }

    // Regex to check if it matches "Number-Number"
    const scoreRegex = /^\d+-\d+$/;

    if (!score || !scoreRegex.test(score)) {
      ToastShow("warning", "Please enter a valid score (e.g., 21-15)");
      return;
    }


    const batch = writeBatch(db);

    batch.update(
      doc(db, "clubs", CLUB_ID, "sessions", sessionId, "matches", match.id),
      {
        status: "finished",
        endedAt: serverTimestamp(),
        score: matchScore || null, // ✅ SAVE SCORE
      }
    );



    match.players.forEach(p => {
      let username = null;
      let photoLink = null;
      if (p.username) {
        username = p.username;
      } if (p.photoURL) {
        photoLink = p.photoURL;
      }
      batch.update(
        doc(db, "clubs", CLUB_ID, "sessions", sessionId, "players", p.id),
        {
          photoURL: photoLink,
          username: username,
          status: "waiting",
          matchId: null,
          waitingSince: Date.now(),
          court: null,
        }
      );

      batch.set(
        doc(db, "clubs", CLUB_ID, "sessions", sessionId, "queue", p.id),
        {
          playerId: p.id,
          photoURL: photoLink,
          username: username,
          name: p.name,
          level: p.level,
          joinedAt: serverTimestamp(),
          waitingSince: Date.now(),
        }
      );
    });

    await batch.commit();

    ToastShow("success", "Game finished");
  };

  const cancelStartedMatch = async (match) => {

    const batch = writeBatch(db);

    // Mark match as cancelled (DON’T DELETE)
    batch.update(
      doc(db, "clubs", CLUB_ID, "sessions", sessionId, "matches", match.id),
      {
        status: "cancelled",
        endedAt: serverTimestamp(),
      }
    );

    // Revert players
    match.players.forEach(p => {
      let username = null;
      let photoLink = null;
      if (p.username) {
        username = p.username;
      } if (p.photoURL) {
        photoLink = p.photoURL;
      }
      batch.update(
        doc(db, "clubs", CLUB_ID, "sessions", sessionId, "players", p.id),
        {
          status: "waiting",
          court: null,
          waitingSince: p.waitingSince,
        }
      );

      batch.set(
        doc(db, "clubs", CLUB_ID, "sessions", sessionId, "queue", p.id),
        {
          playerId: p.id,
          photoURL: photoLink,
          username: username,
          name: p.name,
          level: p.level,
          waitingSince: p.waitingSince || null,
          joinedAt: p.joinedAt,
        },
        { merge: true }
      );
    });

    await batch.commit();
    ToastShow("info", "Match cancelled");
  };


  const renderTeams = (match = []) => {
    if (!Array.isArray(match) || match.length < 4) {
      return <span className="text-muted fst-italic small">Invalid matchup</span>;
    }

    const TeamBlock = ({ p1, p2, align = "start", team }) => (
      <div className={`d-flex align-items-center gap-2 ${align === "end" ? "flex-row-reverse text-end" : "text-start"}`} style={{ flex: 1 }}>
        <div className="lh-1">
          <div className="fw-bold mb-0" style={{ fontSize: '0.85rem' }}>
            {p1?.name.split(' ')[0]} & {p2?.name.split(' ')[0]}
          </div>
          <div className="text-muted" style={{ fontSize: '0.65rem' }}>Team {team}</div>
        </div>
      </div>
    );

    return (
      <div className="d-flex align-items-center justify-content-between gap-3 py-1">
        {/* Team 1 */}
        <TeamBlock p1={match[0]} p2={match[1]} align="end" team="A" />

        {/* Modern VS Divider */}
        <div className="position-relative">
          <div
            className="fw-black text-muted opacity-50 italic"
            style={{ fontSize: '0.7rem', letterSpacing: '1px' }}
          >
            VS
          </div>
        </div>

        {/* Team 2 */}
        <TeamBlock p1={match[2]} p2={match[3]} align="start" team="B" />
      </div>
    );
  };

  const getAverageLevel = (p1, p2) => {
    // if both are missing
    if (!p1 && !p2) return 0;

    // build a temporary array of only existing players
    const players = [];
    if (p1) players.push(p1);
    if (p2) players.push(p2);

    // compute average level
    const total = players.reduce(
      (sum, p) => sum + (playerLevels[p.name] || 1),
      0
    );

    return (total / players.length).toFixed(1);
  };


  const getPlayerLevelMatchStats = (matchHistory, playerLevels, playerName) => {
    const stats = { sameLevel: 0, higherLevel: 0, lowerLevel: 0 };
    const playerLevel = playerLevels[playerName] || 1;

    matchHistory.forEach(entry => {
      const match = entry.match;
      if (!match || match.length !== 4) return;

      // Find out if the player is in this match
      const isInMatch = match.some(p => p.name === playerName);
      if (!isInMatch) return;

      // Determine player's team and opponent team
      let team = [];
      let opponent = [];

      if (match[0].name === playerName || match[1].name === playerName) {
        team = [match[0], match[1]];
        opponent = [match[2], match[3]];
      } else if (match[2].name === playerName || match[3].name === playerName) {
        team = [match[2], match[3]];
        opponent = [match[0], match[1]];
      } else {
        return; // shouldn't happen, but safety check
      }

      const opponentAvgLevel = (
        (playerLevels[opponent[0].name] || 1) +
        (playerLevels[opponent[1].name] || 1)
      ) / 2;

      if (Math.abs(playerLevel - opponentAvgLevel) < 0.01) {
        stats.sameLevel++;
      } else if (playerLevel > opponentAvgLevel) {
        stats.lowerLevel++;
      } else {
        stats.higherLevel++;
      }
    });

    return stats;
  };
  const playerStatusById = useMemo(() => {
    const map = {};
    players.forEach(p => {
      map[p.id] = p.status || "waiting";
    });
    return map;
  }, [players]);

  const handleLogout = async () => {
    const result = await Swal.fire({
      title: "Logout?",
      html: "Leave the queue and logout?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#dc3545",
      confirmButtonText: "Yes",
      reverseButtons: true,
    });

    if (!result.isConfirmed) return;

    try {
      await logout();
    } catch (err) {
      console.error("Logout failed:", err);
    }
  };
  const handleCourtChange = (newCount) => {
    ToastShow("success", "Court count updated");
    setCourts(parseInt(newCount));
  };
  const adjustScore = (matchId, team, amount) => {
    setMatchScores(prev => {
      const currentMatchScore = prev[matchId] || { a: 0, b: 0 };
      const newScore = Math.max(0, currentMatchScore[team] + amount); // Prevent negative scores

      return {
        ...prev,
        [matchId]: {
          ...currentMatchScore,
          [team]: newScore
        }
      };
    });
  };

  const removePlayer = (index) => {
    setManualSelection(prev => prev.filter((_, i) => i !== index));
  };

  const handleDragEnd = async (event) => {
    const { active, over } = event;
    if (!over || active.id === over.id) return;

    // ---- Manual selection list ----
    const manualOldIndex = manualSelection.findIndex(p => p.id === active.id);
    const manualNewIndex = manualSelection.findIndex(p => p.id === over.id);

    if (manualOldIndex !== -1 && manualNewIndex !== -1) {
      setManualSelection((items) =>
        arrayMove(items, manualOldIndex, manualNewIndex)
      );
      return;
    }

    // ---- Queue matches ----
    const oldIndex = queuedMatches.findIndex(m => m.id === active.id);
    const newIndex = queuedMatches.findIndex(m => m.id === over.id);

    if (oldIndex === -1 || newIndex === -1) return;

    // simulate new order
    const newOrder = arrayMove(queuedMatches, oldIndex, newIndex);

    const movedMatch = newOrder[newIndex];

    let newCreatedAt;

    if (newIndex === 0) {
      newCreatedAt = newOrder[1].createdAt - 1000;
    }
    else if (newIndex === newOrder.length - 1) {
      newCreatedAt = newOrder[newIndex - 1].createdAt + 1000;
    }
    else {
      const prev = newOrder[newIndex - 1];
      const next = newOrder[newIndex + 1];
      newCreatedAt = (prev.createdAt + next.createdAt) / 2;
    }

    await updateDoc(
      doc(db, "clubs", CLUB_ID, "sessions", sessionId, "matches", movedMatch.id),
      { createdAt: newCreatedAt }
    );
  };

  const moveMatchUp = async (index) => {
    if (index === 0) return;

    const current = queuedMatches[index];
    const above = queuedMatches[index - 1];

    const batch = writeBatch(db);

    batch.update(
      doc(db, "clubs", CLUB_ID, "sessions", sessionId, "matches", current.id),
      { createdAt: above.createdAt }
    );

    batch.update(
      doc(db, "clubs", CLUB_ID, "sessions", sessionId, "matches", above.id),
      { createdAt: current.createdAt }
    );

    await batch.commit();
  };

  const moveMatchDown = async (index) => {
    if (index === queuedMatches.length - 1) return;

    const current = queuedMatches[index];
    const below = queuedMatches[index + 1];

    const batch = writeBatch(db);

    batch.update(
      doc(db, "clubs", CLUB_ID, "sessions", sessionId, "matches", current.id),
      { createdAt: below.createdAt }
    );

    batch.update(
      doc(db, "clubs", CLUB_ID, "sessions", sessionId, "matches", below.id),
      { createdAt: current.createdAt }
    );

    await batch.commit();
  };
  const moveMatchToTop = async (index) => {
    if (index === 0) return;

    const match = queuedMatches[index];
    const firstMatch = queuedMatches[0];

    const newCreatedAt = firstMatch.createdAt - 1;

    await updateDoc(
      doc(db, "clubs", CLUB_ID, "sessions", sessionId, "matches", match.id),
      { createdAt: newCreatedAt }
    );
  };

  const filteredPlaying = playing
    .filter((match, idx) => {
      if (!courtFilter) return true;
      return String(match.court || idx + 1) === courtFilter;
    })
    .slice()
    .sort((a, b) => {
      const aTime = a.startedAt?.toMillis?.() ?? 0;
      const bTime = b.startedAt?.toMillis?.() ?? 0;
      return sortStarted === "oldest" ? aTime - bTime : bTime - aTime;
    });


  if (!authReady) {
    return (
      <div
        className="position-fixed top-0 start-0 w-100 h-100 d-flex flex-column align-items-center justify-content-center bg-card"
        style={{ zIndex: 9999, backdropFilter: "blur(4px)" }}
      >
        <div
          className="spinner-border mb-3"
          style={{
            color: THEME_COLOR,
            width: "3rem",
            height: "3rem",
            borderWidth: "0.25em",
          }}
        />
        <div className="fw-bold text-muted small text-uppercase tracking-widest">
          Authenticating...
        </div>
      </div>
    );
  }
  //console.log(manualSelection)
  //helper
  const avgA =
    manualSelection.length >= 2
      ? getAverageLevel(manualSelection[0], manualSelection[1])
      : 0;

  const avgB =
    manualSelection.length >= 4
      ? getAverageLevel(manualSelection[2], manualSelection[3])
      : 0;

  const diff = Math.abs(avgA - avgB);

  // tweak threshold if you want
  const BALANCE_THRESHOLD = 0.25;

  const isBalanced =
    manualSelection.length === 4 && diff <= BALANCE_THRESHOLD;

  const teamAGlobal = manualSelection.slice(0, 2);
  const teamBGlobal = manualSelection.slice(2, 4);

  const rivalries =
    manualSelection.length === 4
      ? getRivalries(teamAGlobal, teamBGlobal)
      : [];
  const announceMatch = (match, idx) => {
    if (!("speechSynthesis" in window)) {
      ToastShow("error", "Speech not supported on this device.");
      return;
    }

    const courtNumber = match.court || idx + 1;

    const teamA = match.players.slice(0, 2).map(p => p.name).join(" and ");
    const teamB = match.players.slice(2, 4).map(p => p.name).join(" and ");

    const text = `Court ${courtNumber}. ${teamA} versus ${teamB}. Please proceed to court ${courtNumber}.`;

    const utterance = new SpeechSynthesisUtterance(text);
    utterance.rate = 0.95;
    utterance.pitch = 1;
    utterance.lang = "en-US";

    window.speechSynthesis.cancel(); // stop previous speech
    window.speechSynthesis.speak(utterance);
  };

  return (

    <div className="container-fluid min-vh-100 p-0 d-flex flex-column flex-md-row app-container">
      {/* SIDEBAR (Desktop) / TOPBAR (Mobile) */}
      <div
        className=" d-flex flex-row flex-md-column align-items-center px-3 py-2 text-white shadow-sm"
        style={{
          backgroundColor: THEME_COLOR,
          width: '100%',
          maxWidth: isCollapsed ? '60px' : '210px',
          height: '60px', // Fixed height for Mobile
          minHeight: '60px',
          position: 'sticky',
          top: 0,
          zIndex: 1050,
        }}
      >
        {/* MOBILE & DESKTOP BRANDING */}
        <div className="d-flex flex-row flex-md-column align-items-center w-auto w-md-100">
          <img
            src="/img/rrc.png"
            alt="Logo"
            width={35}
            height={35}
            className="rounded-circle border border-1 border-white border-opacity-50 shadow-sm"
          />

          {/* Hide text on mobile to save space, show on desktop unless collapsed */}
          {!isCollapsed && (
            <div className="ms-2 ms-md-0 mt-md-2 text-start text-md-center d-md-block">
              <h6 className="fw-bold mb-0 d-inline d-md-block small">{user.displayName}</h6>
              <h6 className="fw-bold mb-0 d-inline d-md-block small">{`Admin`}</h6>
            </div>
          )}
        </div>

        {/* DESKTOP COLLAPSE TOGGLE (Hidden on Mobile) */}
        <button
          onClick={() => setIsCollapsed(!isCollapsed)}
          className="btn btn-sm text-white border-0 p-0 d-none d-md-block my-3 opacity-50 hover-opacity-100"
        >
          <i className={`bi bi-arrow-bar-${isCollapsed ? 'right' : 'left'} fs-5`}></i>
        </button>

        {/* ACTION BUTTONS (Icons only on mobile) */}
        <div className="ms-auto ms-md-0 w-auto w-md-100 mt-md-auto mb-md-3 d-flex flex-row flex-md-column gap-1 gap-md-2">

          {/* Players Button */}
          <button
            onClick={() => setShowPlayersModal(true)}
            className="nav-icon-btn"
          >
            <i className="bi bi-people"></i>
            {!isCollapsed && <span className="d-none d-md-inline ms-2">Players</span>}
          </button>
          {/* Players Button */}
          <button
            onClick={() => setCalcOpen(true)}
            className="nav-icon-btn"
          >
            <i className="bi bi-calculator"></i>
            {!isCollapsed && <span className="d-none d-md-inline ms-2">Calculator</span>}
          </button>
          {/* QR Scanner Button */}
          <button
            onClick={() => setShowScan(true)}
            className="nav-icon-btn"
          >
            <i className="bi bi-qr-code-scan fs-4"></i>
            {!isCollapsed && <span className="d-none d-md-inline ms-2">Scan QR Code</span>}
          </button>
          {/* Show QR Button */}
          <button
            onClick={() => setShowQr(true)}
            className="nav-icon-btn"
          >
            <i className="bi bi-qr-code"></i>
            {!isCollapsed && <span className="d-none d-md-inline ms-2">Session QR Code</span>}
          </button>

          {/* Payment Tracker Button */}
          <button
            onClick={() => setShowPaymentModal(true)}
            className="nav-icon-btn"
          >
            <i className="bi bi-wallet2"></i>
            {!isCollapsed && <span className="d-none d-md-inline ms-2">Payment Tracker</span>}
          </button>

          {/* Settings Button */}
          <button onClick={() => setShowSettings(true)} className="nav-icon-btn">
            <i className="bi bi-gear-fill"></i>
            {!isCollapsed && <span className="d-none d-md-inline ms-2">Settings</span>}
          </button>

          {/* Logout Button */}
          <button onClick={handleLogout} className="nav-icon-btn logout-accent">
            <i className="bi bi-box-arrow-right"></i>
            {!isCollapsed && <span className="d-none d-md-inline ms-2">Logout</span>}
          </button>

        </div>

        <style>{`
    .transition-all { transition: all 0.3s ease; }
    
    .nav-icon-btn {
      background: rgba(255, 255, 255, 0.1);
      border: none;
      color: white;
      display: flex;
      align-items: center;
      justify-content: center;
      width: 40px;
      height: 40px;
      border-radius: 10px;
      transition: all 0.2s;
    }

    .logout-accent:hover { background: #dc3545 !important; }

    /* Desktop Sidebar Overrides */
    @media (min-width: 768px) {
      div[style*="position: sticky"] {
        height: 100vh !important;
        position: fixed !important;
        left: 0;
        padding-top: 2rem !important;
        padding-bottom: 2rem !important;
      }
      .nav-icon-btn {
        width: 100%;
        height: auto;
        padding: 10px 15px;
        justify-content: ${isCollapsed ? 'center' : 'flex-start'};
      }
    }

    /* Mobile Content Adjuster */
    @media (max-width: 767px) {
      div[style*="max-width"] {
        max-width: 100% !important;
      }
    }
  `}</style>
      </div>

      {/* MAIN CONTENT AREA */}
      <div style={{
        marginLeft: '0', // Default for mobile
        paddingTop: '10px',
        flex: 1, // Allow this area to grow and fill the width
        minWidth: 0 // Prevents grid blowouts
      }}
        className="transition-all px-2 px-md-4 main-content-wrapper"
      >
        <style>{`
    @media (min-width: 768px) {
      .main-content-wrapper {
        margin-left: ${isCollapsed ? '45px' : '200px'} !important;
      }
    }
  `}</style>
        {/* HERO HEADER - Compacted */}

        <AdminSessionBar setDarkMode={setDarkMode} darkMode={darkMode} />
        <AdminMatchRequests clubId={CLUB_ID} sessionId={sessionId} players={queue} setManualSelection={setManualSelection} playerList={players} />
        {/* BENTO GRID LAYOUT */}
        <div className="row g-2">

          {/* LEFT COLUMN: PLAYER MANAGEMENT (35% width on desktop) */}
          {/* <div className="col-12 col-lg-5 col-xl-4"> */}
          {/* --- ADD THE QUICK STATS CARD HERE --- */}
          {/* <div className="card border-0 shadow-sm rounded-4 mb-4 overflow-hidden"
              style={{ background: `linear-gradient(135deg, ${THEME_COLOR}, #8e44ad)` }}>
              <div className="card-body text-white p-3">
                <div className="d-flex justify-content-between align-items-center">
                  <div>
                    <div className="small opacity-75 fw-bold text-uppercase tracking-tighter" style={{ fontSize: '0.7rem' }}>
                      Total Courts
                    </div>
                    <div className="h2 mb-0 fw-bold">{courts}</div>
                  </div>

                  <div className="d-flex align-items-center bg-white bg-opacity-25 rounded-pill p-1">
                    <button
                      className="btn btn-link text-white p-0 px-2 text-decoration-none border-0 shadow-none"
                      onClick={() => handleCourtChange(Math.max(1, courts - 1))}
                    >
                      <i className="bi bi-dash-lg fw-bold"></i>
                    </button>
                    <div className="vr opacity-50 mx-1" style={{ height: '20px' }}></div>
                    <button
                      className="btn btn-link text-white p-0 px-2 text-decoration-none border-0 shadow-none"
                      onClick={() => handleCourtChange(courts + 1)}
                    >
                      <i className="bi bi-plus-lg fw-bold"></i>
                    </button>
                  </div>
                 
                </div>

                <div className="mt-2 pt-2 border-top border-white border-opacity-10">
                  <small className="opacity-75">
                    <i className="bi bi-info-circle me-1"></i>
                    Adjusting courts updates the live grid instantly
                  </small>
                </div>
              </div>
            </div> */}
          {/* --- END OF QUICK STATS CARD --- */}

          {/* <div className="card border-0 shadow-sm rounded-4 overflow-hidden">
                  <div style={{ height: '4px', backgroundColor: THEME_COLOR, opacity: 0.8 }}></div>
              <div className="card-body p-4">
                
                <div className="d-flex align-items-center justify-content-between mb-3">
                  <h5 className="fw-bold mb-0 d-flex align-items-center gap-2">
                    <i
                      className="bi bi-people-fill"
                      style={{ color: THEME_COLOR }}
                    />
                    Players
                  </h5>

                  <button
                    className="btn btn-primary rounded-pill"
                    onClick={() => setShowScan(true)}
                  >
                    <i className="bi bi-qr-code-scan me-2" />
                    Scan Player
                  </button>
                </div>

                <BulkAddSection
                  addPlayers={addPlayers2}
                  THEME_COLOR={THEME_COLOR}
                  levelColor={levelColor}
                />
                <PlayersListSection
                  {...{ sessionId, searchTerm, setSearchTerm, players, filteredPlayers, sortBy, setSortBy, sortDirection, setSortDirection, playerLevels, gamesPlayed, playingNames, queuedMatchesNames, queue, playerStatusById, setQueue, setPlayers, matchHistory, getPlayerLevelMatchStats, updatePlayerLevel, levelColor, ToastShow }}
                />
              </div>
            </div> */}
          {/* </div> */}

          {/* RIGHT COLUMN: LIVE OPERATIONS (65% width on desktop) */}
          {/* manual match creator */}
          <div className="col-12 col-lg-12 col-xl-12" ref={targetRef}>

{/* dito po hahaha */}
            {/* 1. MANUAL SELECTION PENDING (PRE-CONFIRMATION) */}
            {manualSelection.length > 0 && (
              <div className="card p-4 rounded-4 border border-2 border-dashed mb-4 bg-card shadow-sm" style={{ borderColor: THEME_COLOR }}>

                <div className="d-flex justify-content-between align-items-center mb-3">
                  <h6 className="fw-bold mb-0 text-uppercase small tracking-wider">
                    <i className="bi bi-hand-index-thumb me-2"></i>Manual Match Construction
                  </h6>
                  <button className="btn btn-sm btn-outline-danger border-0 rounded-pill" onClick={() => setManualSelection([])}>
                    <i className="bi bi-trash"></i>
                  </button>
                </div>

                <DndContext
                  collisionDetection={closestCenter}
                  onDragEnd={handleDragEnd}
                >
                  <SortableContext
                    items={manualSelection.map(p => p.id)}
                    strategy={horizontalListSortingStrategy}
                  >
                    <div className="row g-3 align-items-stretch mb-4">
                      {/* TEAM A */}
                      <div className="col-5">
                        <div className="h-100 p-2 rounded-3 text-center bg-surface">
                          <div className="small fw-bold opacity-75 mb-2 text-uppercase" style={{ fontSize: '0.65rem' }}>
                            Team A
                          </div>

                          <div className="d-flex flex-row gap-2 justify-content-center align-items-center mb-2">
                            {manualSelection.slice(0, 2).map((player, index) => (
                              <div key={player.id} className="position-relative">
                                <span
                                  className="d-flex align-items-center gap-2 px-2 py-1 rounded-pill border shadow-sm transition-all"
                                  style={{
                                    backgroundColor: 'var(--surface-bg)',
                                    border: '1px solid rgba(0,0,0,0.05)',
                                    minWidth: '120px'
                                  }}
                                >
                                  {/* The Actual Draggable Component */}
                                  <DraggablePlayerChip
                                    player={player}
                                    index={index}
                                    onRemove={removePlayer}
                                    levelColor={levelColor}
                                  />

                                  {/* Improved Remove Button */}
                                  <button
                                    className="btn btn-sm p-0 d-flex align-items-center justify-content-center"
                                    style={{
                                      width: '20px',
                                      height: '20px',
                                      borderRadius: '50%',
                                      backgroundColor: 'rgba(255,255,255,0.5)',
                                      transition: 'background 0.2s'
                                    }}
                                    onClick={(e) => {
                                      e.stopPropagation();
                                      removePlayer(index);
                                    }}
                                    onMouseEnter={(e) => e.currentTarget.style.backgroundColor = 'rgba(255,255,255,0.8)'}
                                    onMouseLeave={(e) => e.currentTarget.style.backgroundColor = 'rgba(255,255,255,0.5)'}
                                  >
                                    <i className="bi bi-x text-danger fw-bold" style={{ fontSize: '0.9rem' }} />
                                  </button>
                                </span>
                              </div>
                            ))}
                          </div>

                          {manualSelection.length >= 2 && (
                            <div className="mt-2">
                              {haveBeenTeammates(manualSelection[0], manualSelection[1]) ? (
                                <span className="badge bg-danger-subtle text-danger border border-danger-subtle rounded-pill w-100 mb-1" style={{ fontSize: '0.65rem' }}>
                                  Already Paired
                                </span>
                              ) : (
                                <span className="badge bg-success-subtle text-success border border-success-subtle rounded-pill w-100 mb-1" style={{ fontSize: '0.65rem' }}>
                                  New Pairing
                                </span>
                              )}
                              <span className="badge bg-secondary-subtle text-secondary border border-secondary-subtle rounded-pill w-100" style={{ fontSize: '0.65rem' }}>
                                Avg Level ({getAverageLevel(manualSelection[0], manualSelection[1])})
                              </span>
                            </div>
                          )}
                        </div>
                      </div>

                      {/* VS */}
                      <div className="col-2 d-flex flex-column align-items-center justify-content-center gap-2">
                        <span className="fw-bold text-muted">vs</span>

                        {manualSelection.length === 4 && (
                          <span
                            className={`badge rounded-pill px-3 py-1 ${isBalanced
                              ? "bg-success-subtle text-success border border-success-subtle"
                              : "bg-warning-subtle text-warning border border-warning-subtle"
                              }`}
                            style={{ fontSize: "0.65rem" }}
                          >
                            {isBalanced ? "Balanced Match" : `⚠️ ${diff.toFixed(1)} Level Diff`}
                          </span>
                        )}

                        {rivalries.length > 0 && (
                          <div className="mt-2 d-flex flex-column gap-1">
                            {rivalries.map((r, i) => (
                              <span
                                key={i}
                                className="badge bg-danger-subtle text-danger border border-danger-subtle rounded-pill"
                                style={{ fontSize: "0.6rem" }}
                              >
                                ⚔️ {r.a.name} vs {r.b.name} ({r.count}×)
                              </span>
                            ))}
                          </div>
                        )}
                      </div>

                      {/* TEAM B */}
                      <div className="col-5">
                        <div className="h-100 p-2 rounded-3 text-center  bg-surface" >
                          <div className="small fw-bold opacity-75 mb-2 text-uppercase" style={{ fontSize: '0.65rem' }}>
                            Team B
                          </div>

                          <div className="d-flex flex-row gap-2 justify-content-center align-items-center mb-2">
                            {manualSelection.slice(2, 4).map((player, index) => (
                              <>
                                <span
                                  className="d-flex align-items-center gap-2 px-2 py-1 rounded-pill border shadow-sm transition-all"
                                  style={{
                                    backgroundColor: 'var(--surface-bg)',
                                    border: '1px solid rgba(0,0,0,0.05)',
                                    minWidth: '120px'
                                  }}
                                >
                                  <DraggablePlayerChip
                                    key={player.id}
                                    player={player}
                                    index={index + 2}
                                    onRemove={removePlayer}
                                    levelColor={levelColor}
                                  />
                                  {/* Improved Remove Button */}
                                  <button
                                    className="btn btn-sm p-0 d-flex align-items-center justify-content-center"
                                    style={{
                                      width: '20px',
                                      height: '20px',
                                      borderRadius: '50%',
                                      backgroundColor: 'rgba(255,255,255,0.5)',
                                      transition: 'background 0.2s'
                                    }}
                                    onClick={(e) => {
                                      e.stopPropagation();
                                      removePlayer(index + 2);
                                    }}
                                    onMouseEnter={(e) => e.currentTarget.style.backgroundColor = 'rgba(255,255,255,0.8)'}
                                    onMouseLeave={(e) => e.currentTarget.style.backgroundColor = 'rgba(255,255,255,0.5)'}
                                  >
                                    <i className="bi bi-x text-danger fw-bold" style={{ fontSize: '0.9rem' }} />
                                  </button>
                                </span>
                              </>
                            ))}
                          </div>

                          {manualSelection.length === 4 && (
                            <div className="mt-2">
                              {haveBeenTeammates(manualSelection[2], manualSelection[3]) ? (
                                <span className="badge bg-danger-subtle text-danger border border-danger-subtle rounded-pill w-100 mb-1" style={{ fontSize: '0.65rem' }}>
                                  Already Paired
                                </span>
                              ) : (
                                <span className="badge bg-success-subtle text-success border border-success-subtle rounded-pill w-100 mb-1" style={{ fontSize: '0.65rem' }}>
                                  New Pairing
                                </span>
                              )}
                              <span className="badge bg-secondary-subtle text-secondary border border-secondary-subtle rounded-pill w-100" style={{ fontSize: '0.65rem' }}>
                                Avg Level ({getAverageLevel(manualSelection[2], manualSelection[3])})
                              </span>
                            </div>
                          )}
                        </div>
                      </div>
                    </div>

                    {manualSelection.length < 4 && (
                      <div className="text-center py-2 bg-surface rounded-3 mb-4">
                        <div className="spinner-grow spinner-grow-sm text-secondary me-2" role="status"></div>
                        <span className="text-muted small">Pick <strong>{4 - manualSelection.length}</strong> more from the pool...</span>
                      </div>
                    )}
                  </SortableContext>
                </DndContext>
                {manualSelection.length === 4 && (
                  <button
                    onClick={() => { startManualMatch(); setManualSelection([]); }}
                    disabled={manualSelection.length !== 4}
                    className="btn text-white w-100 rounded-pill py-2 fw-bold shadow-sm"
                    style={{
                      backgroundColor: manualSelection.length === 4 ? THEME_COLOR : '#ccc',
                      border: 'none',
                      opacity: manualSelection.length === 4 ? 1 : 0.6
                    }}
                  >
                    {manualSelection.length === 4 ? 'Confirm & Finalize Match' : 'Waiting for Players...'}
                  </button>
                )}
              </div>

            )}

          </div>


          {/* <div className="card shadow-sm rounded-4 overflow-hidden mb-4">
                <div style={{ height: '4px', backgroundColor: THEME_COLOR, opacity: 0.8 }}></div>

                <div className="card-header bg-card px-4 pt-3 pb-0 d-flex justify-content-between align-items-center">
                  <h5 className="fw-bold" style={{ letterSpacing: '0.5px' }}>
                    Awaiting Assignment
                  </h5> */}

          {/* pending and ongoing matches */}
          <div className="col-12 col-lg-12 col-xl-12">
            {/* 4. THE CONFIRMATION BLOCK (For both Manual & Auto) */}
            {queuedMatches.length > 0 && (
              <div className="card shadow-sm rounded-4 overflow-hidden mb-4">
                <div style={{ height: '4px', backgroundColor: THEME_COLOR, opacity: 0.8 }}></div>

                <div className="card-header bg-card px-4 pt-3 pb-0 d-flex justify-content-between align-items-center">
                  <h5 className="fw-bold" style={{ letterSpacing: '0.5px' }}>
                    Awaiting Assignment
                  </h5>
                  <span
                    className="badge rounded-pill border fw-bold"
                    style={{
                      fontSize: "0.65rem",
                      background: "var(--surface-bg)",
                      border: "1px solid var(--border-color)",
                      color: "var(--text-color)"
                    }}
                  >
                    {queuedMatches.length} Pending
                  </span>
                </div>

                <div
                  className="card-body p-0 px-2 px-md-3 custom-scrollbar"
                  style={{
                    maxHeight: '400px',
                    overflowY: 'auto',
                    overflowX: 'hidden'
                  }}
                >
                  <DndContext
                    onDragEnd={handleDragEnd}
                    collisionDetection={closestCenter}
                  >

                    <SortableContext
                      items={queuedMatches.map(m => m.id)}
                      strategy={verticalListSortingStrategy}
                    >
                      <div className="list-group list-group-flush">
                        {queuedMatches.map((match, idx) => (
                          <DraggableMatchRow
                            key={match.id}
                            match={match}
                            idx={idx}
                            queuedMatches={queuedMatches}
                            moveMatchToTop={moveMatchToTop}
                            moveMatchUp={moveMatchUp}
                            moveMatchDown={moveMatchDown}
                          >

                            {/* Match Content */}
                            <div
                              className="d-flex align-items-center justify-content-center gap-1 gap-md-2 flex-grow-1 w-100"
                              style={{ minWidth: 0 }}
                              onClick={() => {
                                setCourtModalMatch(match);
                                setShowCourtModal(true);
                              }}
                            >

                              {/* TEAM A */}
                              <div
                                className="d-flex justify-content-end align-items-center gap-1 flex-grow-1"
                                style={{ minWidth: 0, flexBasis: 0 }}
                              >
                                {[match.players[0], match.players[1]].map((p, i) => (
                                  <div
                                    key={`A-${p?.id ?? i}`}
                                    className="d-flex align-items-center gap-2 rounded-pill px-2 py-1 border shadow-sm"
                                    style={{
                                      backgroundColor: `${levelColor(p.level)}20`,
                                      border: `1px solid ${levelColor(p.level)}40`,
                                      minWidth: 0
                                    }}
                                  >
                                    <span
                                      className="badge rounded-circle flex-shrink-0 shadow-sm"
                                      style={{
                                        backgroundColor: levelColor(p.level),
                                        width: "22px",
                                        height: "22px",
                                        fontSize: "0.6rem",
                                        color: "black",
                                        display: "flex",
                                        alignItems: "center",
                                        justifyContent: "center",
                                        fontWeight: "900"
                                      }}
                                    >
                                      {p.level}
                                    </span>

                                    <div className="d-flex flex-column" style={{ minWidth: 0 }}>
                                      <span
                                        className="fw-bold text-truncate"
                                        title={p.name}
                                        style={{ fontSize: "0.75rem", maxWidth: "90px" }}
                                      >
                                        {p.name}
                                      </span>

                                      <SmartWaitingBadge
                                        waitingSince={p.waitingSince}
                                        longWaitThreshold={longWaitThreshold}
                                        timeHeight={"10px"}
                                      />
                                    </div>
                                  </div>
                                ))}
                              </div>

                              {/* VS */}
                              <div className="flex-shrink-0 mx-1 d-flex align-items-center">
                                <span
                                  className="badge border rounded-pill fw-black opacity-75"
                                  style={{
                                    fontSize: "0.5rem",
                                    padding: "3px 6px",
                                    background: "var(--surface-bg)",
                                    color: "var(--text-muted)",
                                    borderColor: "var(--border-color)"
                                  }}
                                >
                                  VS
                                </span>
                              </div>

                              {/* TEAM B */}
                              <div
                                className="d-flex justify-content-start align-items-center gap-1 flex-grow-1"
                                style={{ minWidth: 0, flexBasis: 0 }}
                              >
                                {[match.players[2], match.players[3]].map((p, i) => (
                                  <div
                                    key={`B-${p?.id ?? i}`}
                                    className="d-flex align-items-center gap-1 rounded-pill px-2 py-1 border shadow-sm"
                                    style={{
                                      backgroundColor: `${levelColor(p.level)}20`,
                                      border: `1px solid ${levelColor(p.level)}40`,
                                      minWidth: 0
                                    }}
                                  >
                                    <span
                                      className="badge rounded-circle flex-shrink-0 shadow-sm"
                                      style={{
                                        backgroundColor: levelColor(p.level),
                                        width: "18px",
                                        height: "18px",
                                        fontSize: "0.6rem",
                                        color: "black",
                                        display: "flex",
                                        alignItems: "center",
                                        justifyContent: "center",
                                        fontWeight: "900"
                                      }}
                                    >
                                      {p.level}
                                    </span>

                                    <div className="d-flex flex-column" style={{ minWidth: 0 }}>
                                      <span
                                        className="fw-bold text-truncate"
                                        title={p.name}
                                        style={{ fontSize: "0.75rem", maxWidth: "90px" }}
                                      >
                                        {p.name}
                                      </span>

                                      <SmartWaitingBadge
                                        waitingSince={p.waitingSince}
                                        longWaitThreshold={longWaitThreshold}
                                        timeHeight={"10px"}
                                      />
                                    </div>
                                  </div>
                                ))}
                              </div>

                            </div>

                          </DraggableMatchRow>
                        ))}
                      </div>
                    </SortableContext>
                  </DndContext>
                </div>

                <style>{`
                .border-bottom-dashed { border-bottom: 1px dashed #e9ecef !important; }
                .border-bottom-dashed:last-child { border-bottom: none !important; }
                .fw-black { font-weight: 900; }
                .custom-scrollbar::-webkit-scrollbar { width: 4px; }
                .custom-scrollbar::-webkit-scrollbar-thumb { background: var(--border-color); border-radius: 10px; }
              `}</style>
              </div>
            )}
          </div>
          {/* player queue */}
          <div className="col-12 col-lg-12 col-xl-12">
            <div className="d-flex flex-column gap-4">
              {/* MATCH MAKER CARD */}
              <div className="card shadow-sm rounded-4 overflow-hidden">

                <div style={{ height: '4px', backgroundColor: THEME_COLOR, opacity: 0.8 }}></div>
                <div className="card-header bg-card d-flex flex-column flex-md-row justify-content-between align-items-md-center gap-2 mb-3">
                  {/* Left: Title & Stats */}
                  <div className="d-flex align-items-center gap-3">
                    <h5 className="fw-bold" style={{ letterSpacing: '0.5px' }}>
                      Match Maker
                    </h5>

                    <div className="d-flex gap-1">
                      {[
                        { label: 'Available', count: queue.length, color: 'text-primary' },
                        { label: 'Queued', count: queuedMatches.length * 4, color: 'text-warning' },
                        { label: 'Playing', count: playing.length * 4, color: 'text-success' }
                      ].map((stat, i) => (
                        <div key={i} className="badge rounded-pill bg-card border d-flex align-items-center py-1 px-2 shadow-sm" style={{ fontSize: '0.6rem' }}>
                          <span className={`${stat.color} fw-black me-1`}>{stat.count}</span>
                          <span className="text-muted opacity-50 fw-bold">{stat.label}</span>
                        </div>
                      ))}
                    </div>
                  </div>

                  {/* Right: Compact Search */}
                  <div style={{ width: '220px' }}>
                    <div className="input-group input-group-sm shadow-sm">
                      <span className="input-group-text bg-surface  rounded-start-pill ps-3">
                        <i className="bi bi-search text-muted" style={{ fontSize: '0.75rem' }}></i>
                      </span>
                      <input
                        type="text"
                        className="form-control bg-surface rounded-end-pill py-1 fw-medium"
                        style={{ fontSize: '0.75rem' }}
                        placeholder="Search player..."
                        value={queueSearch}
                        onChange={(e) => setQueueSearch(e.target.value)}
                      />
                      {queueSearch && (
                        <button
                          className="btn rounded-circle position-absolute end-0 top-50 translate-middle-y me-1"
                          style={{ zIndex: 5, padding: '0 5px' }}
                          onClick={() => setQueueSearch("")}
                        >
                          <i className="bi bi-x-circle-fill text-muted opacity-50" style={{ fontSize: '0.8rem' }}></i>
                        </button>
                      )}
                    </div>
                  </div>
                </div>
                <div className="card-body p-4">


                  {/* 2. PLAYER GRID (THE POOL) */}
                  <div className="mb-4">
                    <QueuePlayerGrid
                      queue={queue}
                      searchTerm={queueSearch}
                      manualSelection={manualSelection}
                      setManualSelection={setManualSelection}
                      playerLevels={playerLevels}
                      gamesPlayed={gamesPlayed}
                      levelColor={levelColor}
                      colsCount={colsCount}
                      longWaitThreshold={longWaitThreshold}
                      setLongWaitThreshold={setLongWaitThreshold}
                    />
                  </div>

                  {/* 3. AUTO MATCH TRIGGER */}
                  {/* AUTO MATCH SECTION */}
                  {showAutoMatch && (
                    <div className="p-4 bg-surface rounded-4 border mb-4 shadow-sm">
                      <div className="d-flex align-items-center justify-content-between mb-3">
                        <div className="d-flex align-items-center gap-2">
                          <div className="p-2 bg-card rounded-circle shadow-sm">
                            <i className="bi bi-robot fs-5" style={{ color: THEME_COLOR }}></i>
                          </div>
                          <div>
                            <h6 className="fw-bold mb-0">Smart Matchmaker</h6>
                            <p className="text-muted mb-0" style={{ fontSize: '0.75rem' }}>Auto-pair the best balanced teams</p>
                          </div>
                        </div>
                        <button
                          onClick={confirmAutoMatch}
                          className="btn text-white rounded-pill px-4 shadow-sm fw-bold"
                          style={{ backgroundColor: THEME_COLOR, border: 'none' }}
                          disabled={manualSelection.length > 0}
                        >
                          <i className="bi bi-lightning-fill me-1"></i> Generate
                        </button>
                      </div>
                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>
          <div className="col-12 col-lg-12 col-xl-12">
            {/* ONGOING MATCHES CARD */}
            <div className="card shadow-sm rounded-4 overflow-hidden">
              <div style={{ height: '4px', backgroundColor: THEME_COLOR, opacity: 0.8 }}></div>
              <div className="card-header bg-card px-4 pt-3 pb-2 d-flex justify-content-between align-items-center flex-wrap gap-2">

                <div className="d-flex align-items-center gap-2">
                  <h5 className="fw-bold mb-0">Live Courts</h5>

                  <span
                    className="badge rounded-pill border fw-bold"
                    style={{
                      fontSize: "0.65rem",
                      background: "var(--surface-bg)",
                      border: "1px solid var(--border-color)",
                      color: "var(--text-color)"
                    }}
                  >
                    {filteredPlaying.length} Playing
                  </span>
                </div>

                <div className="d-flex gap-2">

                  {/* Court Filter */}
                  <select
                    className="form-select form-select-sm rounded-pill"
                    style={{ width: "100px", fontSize: "0.75rem" }}
                    value={courtFilter}
                    onChange={(e) => setCourtFilter(e.target.value)}
                  >
                    <option value="">All Courts</option>
                    {[...new Set(playing.map((m, i) => m.court || i + 1))].map((court) => (
                      <option key={court} value={court}>
                        Court {court}
                      </option>
                    ))}
                  </select>

                  {/* Started At Sort */}
                  <select
                    className="form-select form-select-sm rounded-pill"
                    style={{ width: "120px", fontSize: "0.75rem" }}
                    value={sortStarted}
                    onChange={(e) => setSortStarted(e.target.value)}
                  >
                    <option value="oldest">Oldest</option>
                    <option value="newest">Newest</option>
                  </select>

                </div>
              </div>
              <div
                className="card-body pt-2 px-3 custom-scrollbar"
                style={{
                  maxHeight: '750px',
                  overflowY: 'auto',
                  overflowX: 'hidden'
                }}
              >
                <div className="row g-3">
                  {filteredPlaying.length === 0 ? (
                    <div className="text-center py-4 text-muted small">No active matches. Assign a court to start.</div>
                  ) : (
                    filteredPlaying
                      .slice()
                      // .sort((a, b) => {
                      //   const aTime = a.startedAt?.toMillis?.() ?? 0;
                      //   const bTime = b.startedAt?.toMillis?.() ?? 0;
                      //   return aTime - bTime;
                      // })
                      .map((match, idx) => {
                        //console.log(match)
                        return (
                          <div className="col-md-6 mb-2" key={match.id}>
                            <div className="p-2 border rounded-4 bg-surface shadow-sm">
                              {/* Header: Smaller text, tighter margin */}
                              <div className="d-flex justify-content-between align-items-center mb-1 px-1">
                                <span className="fw-bold px-2 py-0 bg-card rounded border" style={{ fontSize: '0.7rem' }}>
                                  Court {match.court || idx + 1}
                                </span>
                                <button
                                  className="btn btn-sm btn-primary rounded-pill flex-shrink-0"
                                  onClick={() => announceMatch(match, idx)}
                                >
                                  <i className="bi bi-megaphone-fill"></i>
                                </button>
                                {match.startedAt && <MatchTimer startTime={match.startedAt} />}
                              </div>

                              {/* Team Section */}
                              <div className="py-1">
                                {renderTeams(match.players)}
                              </div>

                              {/* Actions: Compact Single Row */}
                              <div className="mt-2 d-flex align-items-center gap-1">
                                <div className="position-relative flex-grow-1">
                                  <input
                                    type="text"
                                    inputMode="numeric"
                                    className="form-control form-control-sm rounded-pill px-2 shadow-sm border-2 text-center fw-bold"
                                    style={{
                                      height: '30px',
                                      fontSize: '0.8rem',
                                      letterSpacing: '1px',
                                      borderColor: matchScores[match.id] ? THEME_COLOR : '#dee2e6',
                                      width: '100%'
                                    }}
                                    placeholder="Score (eg. 21-23)"
                                    maxLength={5}
                                    value={matchScores[match.id] || ""}

                                    onKeyDown={(e) => {
                                      if (e.key === "Enter") {
                                        e.preventDefault();

                                        const currentScores = matchScores[match.id];
                                        if (!currentScores) {
                                          ToastShow("error", "Please enter the final scores before finishing the match.");
                                          return;
                                        }

                                        Swal.fire({
                                          title: "Finish match?",
                                          text: "Are you sure you want to end this game?",
                                          icon: "warning",
                                          showCancelButton: true,
                                          confirmButtonColor: THEME_COLOR,
                                          cancelButtonColor: "#6c757d",
                                          confirmButtonText: "Yes, end it"
                                        }).then((result) => {
                                          if (result.isConfirmed) {
                                            finishMatch(match, matchScores[match.id]);
                                          }
                                        });
                                      }
                                    }}

                                    onChange={(e) => {
                                      let val = e.target.value.replace(/[^\d-]/g, "");
                                      const isDeleting = e.nativeEvent.inputType === "deleteContentBackward";

                                      if (!isDeleting && val.length === 2 && !val.includes('-')) {
                                        val = val + '-';
                                      }

                                      if (val.startsWith('-')) val = "";

                                      if ((val.match(/-/g) || []).length > 1) {
                                        val = val.replace(/-$/, "");
                                      }

                                      setMatchScores({ ...matchScores, [match.id]: val });
                                    }}
                                  />
                                </div>

                                <button
                                  className="btn btn-sm btn-soft-danger rounded-pill border-0 flex-shrink-0"
                                  style={{ height: '30px', width: '30px', padding: '0', display: 'flex', alignItems: 'center', justifyContent: 'center' }}
                                  onClick={() => {
                                    Swal.fire({
                                      title: `Cancel game?`,
                                      text: "Are you sure you want to cancel this game?",
                                      icon: "warning",
                                      showCancelButton: true,
                                      confirmButtonColor: "#d33",
                                      cancelButtonColor: "#6c757d",
                                      confirmButtonText: "Yes, cancel"
                                    }).then((result) => {
                                      if (result.isConfirmed) {
                                        cancelStartedMatch(match)
                                      }
                                    });
                                  }}
                                >
                                  <i className="bi bi-x-lg" style={{ fontSize: '0.75rem' }}></i>
                                </button>

                                <button
                                  className="btn btn-sm text-white rounded-pill px-3 fw-bold flex-shrink-0"
                                  style={{ backgroundColor: THEME_COLOR, height: '30px', fontSize: '0.7rem' }}
                                  onClick={() => {
                                    const currentScores = matchScores[match.id]; // Corrected to match.id per your logic
                                    if (!currentScores) {
                                      ToastShow("error", "Please enter the final scores before finishing the match.");
                                      return;
                                    }
                                    Swal.fire({
                                      title: "Finish match?",
                                      text: "Are you sure you want to end this game?",
                                      icon: "warning",
                                      showCancelButton: true,
                                      confirmButtonColor: THEME_COLOR,
                                      cancelButtonColor: "#6c757d",
                                      confirmButtonText: "Yes, end it"
                                    }).then((result) => {
                                      if (result.isConfirmed) {
                                        finishMatch(match, matchScores[match.id]);
                                      }
                                    });
                                  }}
                                >
                                  FINISH
                                </button>
                              </div>
                            </div>
                          </div>
                        )
                      })
                  )}

                </div>
              </div>
            </div>
          </div>

         
          
          {/* HISTORY SECTION */}
          <div className="col-12 col-lg-12 col-xl-12">
            <MatchHistorySection matchHistory={matchHistory} renderTeams={renderTeams} onEditMatch={(match) => setEditingMatch(match)} />
          </div>
        </div>
      </div>
      <AdminScanPlayerModal
        show={showScan}
        onClose={() => setShowScan(false)}
        onScanSuccess={joinQueueFromQR}
      />
      <PaymentsCalculatorModal
        show={isCalcOpen}
        onClose={() => setCalcOpen(false)}
        THEME_COLOR={THEME_COLOR}
      />
      {showSettings && (
        <SettingsModal
          show
          clubId={CLUB_ID}
          colsCount={colsCount}
          setColsCount={setColsCount}
          longWaitThreshold={longWaitThreshold}
          setLongWaitThreshold={setLongWaitThreshold}
          lookForPlayers={lookForPlayers}
          setLookForPlayers={setLookForPlayers}
          maxLevelDiff={maxLevelDiff}
          setMaxLevelDiff={setMaxLevelDiff}
          ToastShow={ToastShow}
          showAutoMatch={showAutoMatch}
          setShowAutoMatch={setShowAutoMatch}
          courts={courts}
          handleCourtChange={handleCourtChange}
          defaultTab="sessions"

          limitTeammatesEnabled={limitTeammatesEnabled}
          setLimitTeammatesEnabled={setLimitTeammatesEnabled}
          limitRivalsEnabled={limitRivalsEnabled}
          setLimitRivalsEnabled={setLimitRivalsEnabled}
          maxTeammates={maxTeammates}
          setMaxTeammates={setMaxTeammates}
          maxRivals={maxRivals}
          setMaxRivals={setMaxRivals}
          maxTeamDiff={maxTeamDiff}
          setMaxTeamDiff={setMaxTeamDiff}

          onClose={() => {
            setShowSettings(false);
          }}
        />
      )}
      {showPaymentModal && (
        <SessionPayments
          showPaymentModal={showPaymentModal}
          onClose={() => setShowPaymentModal(false)}
          clubId={CLUB_ID}
          sessionId={sessionId}
          admin={user}
          playerList={players}
          gamesPlayed={gamesPlayed}
        />
      )}
      {editingMatch && (
        <EditMatchModal
          match={editingMatch}
          players={players}
          onClose={() => setEditingMatch(null)}
          clubId={CLUB_ID}
          sessionId={sessionId}
        />
      )}
      {showPlayersModal && (
        <PlayersModal
          show={showPlayersModal}
          onClose={() => setShowPlayersModal(false)}
          setShowScan={setShowScan}

          {...{
            sessionId,
            searchTerm,
            setSearchTerm,
            players,
            filteredPlayers,
            sortBy,
            setSortBy,
            sortDirection,
            setSortDirection,
            playerLevels,
            gamesPlayed,
            playingNames,
            queuedMatchesNames,
            queue,
            playerStatusById,
            setQueue,
            setPlayers,
            matchHistory,
            getPlayerLevelMatchStats,
            updatePlayerLevel,
            levelColor,
            ToastShow,
            addPlayers2,
            colsCount
          }}
        />
      )}
      {showQr && (
        <>
          {/* Clean Backdrop: Styled to be slightly frosted/white instead of dark */}
          <div
            className="qr-backdrop modal-backdrop fade show"
            //style={{ backgroundColor: "rgba(255, 255, 255, 0.9)", backdropFilter: "blur(4px)" }}
            onClick={() => setShowQr(false)}
          />

          <div
            className="modal fade show d-block"
            tabIndex="-1"
            role="dialog"
            aria-modal="true"
            style={{ zIndex: 1055 }}
          >
            <div className="modal-dialog modal-dialog-centered px-3" style={{ maxWidth: '400px' }}>
              <div className="modal-content border-0 shadow-lg rounded-5 overflow-hidden">

                {/* Header with a Violet tint */}
                <div className="modal-header border-0 pb-0 pt-4 px-4 d-flex justify-content-between align-items-center">
                  <h5 className="fw-bold mb-0" >Scan to Join Session</h5>
                  <button
                    type="button"
                    className="btn-close shadow-none"
                    onClick={() => setShowQr(false)}
                  />
                </div>

                <div className="modal-body text-center p-4">
                  <div className="d-flex justify-content-center align-items-center">
                    <div
                      className="p-3 rounded-4"
                      style={{
                        //border: `2px solid ${THEME_COLOR}20`, // Subtle 20% opacity border
                        //boxShadow: `0 20px 40px rgba(124, 58, 237, 0.1)`, // Soft Violet shadow
                        backgroundColor: "#fff"
                      }}
                    >
                      <QRCodeCanvas
                        size={280} // Reduced size slightly for better mobile fit
                        value={joinUrl}
                        bgColor={"#ffffff"}
                        fgColor={THEME_COLOR}
                        level={"H"}
                        imageSettings={{
                          src: "/img/rrc2.png",
                          height: 45,
                          width: 45,
                          excavate: true,
                        }}
                      />
                    </div>
                  </div>

                  <div className="mt-4">
                    <p className="text-muted small px-3">
                      Players can scan this code to register for matches automatically.
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </>
      )}
      {showCourtModal && courtModalMatch && (
        <div className="modal fade show d-block" style={{ background: "rgba(0,0,0,.6)", backdropFilter: "blur(6px)" }}>
          <div className="modal-dialog modal-dialog-centered" style={{ maxWidth: '450px' }}>
            <div className="modal-content rounded-5 border-0 shadow-lg overflow-hidden">

              {/* HEADER */}
              <div className="modal-header border-0 bg-card pt-4 px-4 pb-2">
                <div className="d-flex align-items-center">
                  <div className="bg-primary bg-opacity-10 p-2 rounded-4 me-3">
                    <i className="bi bi-door-open-fill text-primary fs-4"></i>
                  </div>
                  <div>
                    <h5 className="fw-black mb-0">Court Assignment</h5>
                    <p className="text-muted mb-0" style={{ fontSize: '0.75rem' }}>Match Details & Court Selection</p>
                  </div>
                </div>
                <button
                  className="btn-close shadow-none"
                  onClick={() => setShowCourtModal(false)}
                />
              </div>

              <div className="modal-body px-4">

                {/* MATCH PREVIEW CARD */}
                <div className="bg-surface rounded-4 p-3 mb-4 border border-white">
                  <div className="d-flex align-items-center justify-content-between text-center">

                    {/* Team A */}
                    <div className="flex-1">
                      <div className="fw-black text-primary small mb-2 text-uppercase" style={{ letterSpacing: '1px' }}>Team A</div>
                      <div className="d-flex flex-column gap-2">
  {courtModalMatch?.players?.slice(0, 2).map((p, idx) => {
    const bgBgColor = levelColor?.(p.level) || 'var(--bs-surface-bg)';
    
    // HELPER: Calculates the best contrast color (light text for dark bg, dark text for light bg)
    const getContrastText = (hexColor) => {
      if (!hexColor || !hexColor.startsWith('#')) return 'var(--bs-body-color)';
      const color = hexColor.replace('#', '');
      const r = parseInt(color.substring(0, 2), 16);
      const g = parseInt(color.substring(2, 4), 16);
      const b = parseInt(color.substring(4, 6), 16);
      const brightness = (r * 299 + g * 587 + b * 114) / 1000;
      return brightness > 128 ? '#121212' : '#ffffff';
    };

    const textColor = getContrastText(bgBgColor);

    return (
      <div
        key={idx}
        className="d-flex align-items-center justify-content-between px-3 py-2 rounded-3 shadow-sm border"
        style={{ 
          backgroundColor: bgBgColor, 
          borderColor: 'var(--bs-border-color-translucent)',
          minWidth: '160px',
          color: textColor // Ensures crisp text readability on any background hue
        }}
      >
        {/* Player Name Container */}
        <span className="fw-semibold text-truncate me-2" style={{ fontSize: '0.85rem' }}>
          {p.name}
        </span>

        {/* Flexible Dynamic Level Badge */}
        <span
          className="badge d-flex align-items-center justify-content-center fw-bold shadow-sm"
          style={{
            minWidth: "24px", 
            height: "22px",
            padding: "0 6px", 
            borderRadius: "6px", 
            fontSize: "0.65rem",
            // Adapts its backdrop shade seamlessly to match the calculated text visibility
            background: textColor === '#ffffff' ? 'rgba(255, 255, 255, 0.15)' : 'rgba(0, 0, 0, 0.08)', 
            color: textColor, 
            whiteSpace: "nowrap"
          }}
        >
          {LEVELS_MAP[p?.level] ?? "3.5+"}
        </span>
      </div>
    );
  })}
</div>
                    </div>

                    <div className="px-2 fw-black text-muted opacity-25" style={{ fontSize: '0.7rem' }}>VS</div>

                    {/* Team B */}
                    <div className="flex-1">
                      <div className="fw-black text-danger small mb-2 text-uppercase" style={{ letterSpacing: '1px' }}>Team B</div>
                    <div className="d-flex flex-column gap-2">
  {courtModalMatch?.players?.slice(2, 4).map((p, idx) => {
    const bgBgColor = levelColor?.(p.level) || 'var(--bs-surface-bg)';
    
    // HELPER: Simple brightness check if your colors are hex strings (e.g., "#FFFFFF")
    // If your levelColor returns something else, we can use a fallback.
    const getContrastText = (hexColor) => {
      if (!hexColor || !hexColor.startsWith('#')) return 'var(--bs-body-color)';
      const color = hexColor.replace('#', '');
      const r = parseInt(color.substring(0, 2), 16);
      const g = parseInt(color.substring(2, 4), 16);
      const b = parseInt(color.substring(4, 6), 16);
      const brightness = (r * 299 + g * 587 + b * 114) / 1000;
      return brightness > 128 ? '#121212' : '#ffffff'; // Dark gray for light tabs, pure white for dark tabs
    };

    const textColor = getContrastText(bgBgColor);

    return (
      <div
        key={idx}
        className="d-flex align-items-center justify-content-between px-3 py-2 rounded-3 shadow-sm border"
        style={{ 
          backgroundColor: bgBgColor, 
          borderColor: 'var(--bs-border-color-translucent)',
          minWidth: '160px',
          color: textColor // Clean, calculated text color
        }}
      >
        {/* Player Name Container */}
        <span className="fw-semibold text-truncate me-2" style={{ fontSize: '0.85rem' }}>
          {p.name}
        </span>

        {/* Flexible Dynamic Level Badge */}
        <span
          className="badge d-flex align-items-center justify-content-center fw-bold shadow-sm"
          style={{
            minWidth: "24px", 
            height: "22px",
            padding: "0 6px", 
            borderRadius: "6px", 
            fontSize: "0.65rem",
            // Uses a subtle background block that naturally fits either text color
            background: textColor === '#ffffff' ? 'rgba(255, 255, 255, 0.15)' : 'rgba(0, 0, 0, 0.08)', 
            color: textColor, 
            whiteSpace: "nowrap"
          }}
        >
          {LEVELS_MAP[p?.level] ?? "3.5+"}
        </span>
      </div>
    );
  })}
</div>
                    </div>

                  </div>
                </div>

                {/* COURT GRID */}
                <div className="d-flex justify-content-between align-items-end mb-3">
                  <label className="fw-black small text-muted text-uppercase italic" style={{ letterSpacing: '0.5px' }}>
                    Select Court
                  </label>
                  <span className="badge bg-dark rounded-pill opacity-50" style={{ fontSize: '0.6rem' }}>{courts} Available</span>
                </div>

                <div className="row g-2">
                  {[...Array(courts)].map((_, i) => (
                    <div className="col-4" key={i}>
                      <button
                        className="btn btn-white border w-100 py-3 rounded-4 court-card transition-all"
                        onClick={() => {
                          proceedAutoMatch(courtModalMatch.players, i + 1, courtModalMatch.id);
                          setShowCourtModal(false);
                        }}
                      >
                        <div className="text-muted mb-0" style={{ fontSize: '0.55rem', fontWeight: '800' }}>COURT</div>
                        <div className="h4 fw-black mb-0 text-primary">{i + 1}</div>
                      </button>
                    </div>
                  ))}
                </div>
              </div>

              {/* ACTIONS */}
              <div className="modal-footer border-0 p-4 pt-2 mt-2">
                <button
                  className="btn btn-outline-danger w-100 rounded-pill border-0 fw-bold"
                  onClick={() => {
                    cancelPendingMatch(courtModalMatch);
                    setShowCourtModal(false);
                  }}
                >
                  <i className="bi bi-trash3-fill me-2"></i>
                  Discard this Match
                </button>
              </div>

              <style>{`
          .fw-black { font-weight: 900; }
          .flex-1 { flex: 1; }
          .court-card {
            background: var(--card-bg);
            border-color: var(--border-color) !important;
            box-shadow: 0 2px 4px rgba(0,0,0,0.02);
          }
          .court-card:hover {
            border-color: ${THEME_COLOR} !important;
            background: ${THEME_COLOR}08;
            transform: scale(1.02);
            box-shadow: 0 4px 12px rgba(0,0,0,0.08);
          }
          .transition-all {
            transition: all 0.2s cubic-bezier(0.175, 0.885, 0.32, 1.275);
          }
        `}</style>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
